<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/llhvDa/tc-custom/9780062934864.jpg?1731208760402" alt="This image is the cover for the book You and Me and Us"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">You and Me and Us
      </h1>
      <p class="bookDescription body article font2">
        <p><b>“Hammer is an expert at both tugging heartstrings and keeping the reader utterly immersed in a world of hope and heartbreak. A great new voice in women’s fiction.”-- Kristin Harmel, #1 international bestselling author of <i>The Winemaker's Wife</i></b><b><br/></b></p><p><b>The heartbreaking, yet hopeful, story of a mother and daughter struggling to be a family without the one person who holds them together—a perfect summer read for fans of Jojo Moyes and Marisa de los Santos.</b></p><p> Alexis Gold knows how to put the “work” in working mom. It’s the “mom” part that she’s been struggling with lately. Since opening her own advertising agency three years ago, Alexis has all but given up on finding a good work/life balance. Instead, she’s handed over the household reins to her supportive, loving partner, Tommy. While he’s quick to say they divide and conquer, Alexis knows that Tommy does most of the heavy lifting—especially when it comes to their teenage daughter, CeCe. </p><p>Their world changes in an instant when Tommy receives a terminal cancer diagnosis, and Alexis realizes everything she’s worked relentlessly for doesn’t matter without him. So Alexis does what Tommy has done for her almost every day since they were twelve-year-old kids in Destin, Florida—she puts him first. And when the only thing Tommy wants is to spend one last summer together at “their” beach, she puts her career on hold to make it happen…even if it means putting her family within striking distance of Tommy’s ex, an actress CeCe idolizes.</p><p>But Alexis and Tommy aren’t the only ones whose lives have been turned inside out. In addition to dealing with the normal ups and downs that come with being a teenager, CeCe is also forced to confront her feelings about Tommy’s illness—and what will happen when the one person who’s always been there for her is gone. When the magic of first love brings a bright spot to her summer, CeCe is determined not to let her mother ruin that for her, too. </p><p>As CeCe’s behavior becomes more rebellious, Alexis realizes the only thing harder for her than losing Tommy will be convincing CeCe to give her one more chance.  </p><p><i>You and Me and Us</i> is a beautifully written novel that examines the unexpected ways loss teaches us how to love. </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Alison Hammer
      </h2>
      
      <p class="authorDescription body article"><P>Founder of the Every Damn Day Writers, Alison Hammer&#160;has been spinning words to tell stories since she learned how to talk. A graduate of the University of Florida and the Creative Circus in Atlanta, she lived in nine cities before settling down in Chicago, where she works as a VP creative director at an advertising agency. <I>You &#38; Me &#38; Us</I> is her first novel.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollinsPublishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?d1923aea